<template>
  <div class="ap-view-message">
    <div class="header">
      <div class="name">{{ profile.name }}</div>
      <div class="org">{{ profile.orgName }}</div>
    </div>
    <hr />
    <div class="phone">
      <div>账号（绑定手机）</div>
      <div style="color: #333">{{ profile.userPrincipals[0].principal }}</div>
      <div class="change" @click="changePhoneNum">更改绑定手机</div>
    </div>
    <div class="password">
      <div>账号密码</div>
      <div style="color: #333">**********</div>
      <div class="change" @click="changePwd">修改密码</div>
    </div>
    <div class="wechat">
      <div>绑定微信（消息通知）</div>
      <div style="color: #333">
        <div>
          <span v-if="profile.wechatNickname">{{ profile.wechatNickname }}</span>
          <span v-else>未绑定微信号</span>
        </div>
      </div>
      <div class="change" v-if="profile.wechatNickname" @click="unlink">解绑此微信</div>
      <div class="change" v-else @click="bindWeChat">点击绑定</div>
    </div>
    <hr />
    <div class="detail">
      <ul>
        <li>
          <div class="left">头像</div>
          <div class="right" style="overflow: hidden">
            <img v-if="profile.wechatNickname" class="viewHead" :src="headImgUrl" />
            <img v-else class="viewHead" src="@/assets/icons/user.png" />
            <label class="change float-right" for="headFile">修改头像</label>
            <input type="file" @change="changeFile" id="headFile" ref="headFile" style="display: none" />
          </div>
        </li>
        <li>
          <div class="left">姓名</div>
          <div class="right">
            <input type="text" v-model="profile.name" class="form-control" />
          </div>
        </li>
        <li style="height: 56px; display: flex; align-items: center">
          <div class="left">性别</div>
          <div class="right">
            <input type="radio" v-model="profile.gender" value="MALE" /> 男
            <span style="margin: 15px"></span>
            <input type="radio" v-model="profile.gender" value="FEMALE" /> 女
          </div>
        </li>
        <li>
          <div class="left">职务</div>
          <div class="right">
            <input type="text" v-model="profile.position" class="form-control" />
          </div>
        </li>
        <li>
          <div class="left">部门</div>
          <div class="right">
            <input type="text" v-model="profile.department" class="form-control" />
          </div>
        </li>
        <li>
          <div class="left">联系电话</div>
          <div class="right">
            <input type="number" v-model="profile.mobileNumber" class="form-control" />
          </div>
        </li>
        <li>
          <div class="left">电子邮件</div>
          <div class="right">
            <input type="email" v-model="profile.mailAddress" class="form-control" />
          </div>
        </li>
      </ul>
      <div style="padding-top: 30px">
        <button class="btn btn-secondary add" @click="saveDetail">保存信息</button>
      </div>
    </div>
    <Dialog v-if="showDialog1" @close="close" ref="phoneNumDialog" title="修改安全手机" :showFooter="false">
      <hr style="margin: 0" />
      <div style="padding: 20px" v-if="stepDialog1 == 1">
        本操作需要您输入当前的登录密码，以便确认是您本人进行操作。
        <input type="text" class="form-control" style="margin-top: 20px" placeholder="输入登录密码" />
        <button @click="stepDialog1 = 2" class="btn btn-secondary add" style="margin: 40px 0 20px">确认</button>
      </div>
      <div style="padding: 10px" v-if="stepDialog1 == 2">
        <div style="margin: 20px 10px">
          <input type="number" class="form-control" placeholder="输入新的手机号" />
        </div>
        <div class="clearfix" style="margin: 20px 10px">
          <input type="number" class="form-control float-left" placeholder="输入验证码" style="width: 240px" />
          <button class="btn btn-secondary float-right">发送手机验证码</button>
        </div>
        <button @click="affirmPhoneNum" class="btn btn-secondary add" style="margin: 20px 10px">确认修改</button>
      </div>
      <div style="padding: 20px" v-if="stepDialog1 == 3">
        <strong style="font-size: 20px">修改成功！</strong>
        <div style="margin-top: 10px">您的安全手机号码已改为：1xxxxxxxxxx</div>
        <button class="btn btn-secondary" style="margin: 30px 0" @click="$refs.phoneNumDialog.close()">好的</button>
      </div>
    </Dialog>
    <Dialog v-if="showDialog2" @close="close" ref="pwdDialog" title="修改登录密码" :showFooter="false">
      <hr style="margin: 0" />
      <div v-if="stepDialog2 == 1">
        <div style="margin: 20px">本操作需要您输入当前的登录密码，以便确认是您本人进行操作。</div>
        <!-- <div style="margin:20px;">
          <input type="password" class="form-control" placeholder="输入当前密码" />
        </div>-->
        <div style="margin: 20px">
          <input type="password" v-model="newPwd1" class="form-control" placeholder="输入新的密码" />
        </div>
        <div style="margin: 20px">
          <input type="password" v-model="newPwd2" class="form-control" placeholder="重复输入新的密码" />
        </div>
        <button @click="affirmPwd" class="btn btn-secondary add" style="margin: 20px">确认修改</button>
      </div>
      <div style="padding: 20px" v-if="stepDialog2 == 2">
        <strong style="font-size: 20px">修改成功！</strong>
        <div style="margin-top: 10px">您的登录密码已修改，请牢记您的新密码。</div>
        <button class="btn btn-secondary" style="margin: 30px 0" @click="$refs.pwdDialog.close()">好的</button>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Dialog from "@/components/Dialog.vue";
import { mapState } from "vuex";

export default {
  components: {
    Dialog,
  },
  data() {
    return {
      showDialog1: false,
      stepDialog1: 1,
      showDialog2: false,
      stepDialog2: 1,
      newPwd1: "",
      newPwd2: "",
      profile: {
        name: "",
        gender: "",
        position: "",
        department: "",
        mobileNumber: "",
        mailAddress: "",
        userPrincipals: [{}],
      },
    };
  },
  computed: {
    ...mapState(["headImgUrl"]),
  },
  created() {
    this.getProfile();
  },
  methods: {
    bindWeChat() {
      const passportUrl = process.env.VUE_APP_PASSPORT_URL;
      let uri = `${passportUrl}/#/login?redirectUrl=${encodeURIComponent(location.href + "?phone=") + this.profile.userPrincipals[0].principal}`;
      window.location.replace(uri);
    },
    close() {
      this.stepDialog1 = 1;
      this.stepDialog2 = 1;
    },
    changePhoneNum() {
      this.showDialog1 = true;
      if (!this.$refs.phoneNumDialog) return;
      this.$refs.phoneNumDialog.show();
    },
    changePwd() {
      this.showDialog2 = true;
      if (!this.$refs.pwdDialog) return;
      this.$refs.pwdDialog.show();
    },
    affirmPhoneNum() {
      this.stepDialog1 = 3;
    },
    affirmPwd() {
      if (this.newPwd1.length < 6 || this.newPwd2.length < 6) return $msg.warning("密码至少六位数", 3);
      if (this.newPwd1 !== this.newPwd2) return $msg.warning("两次输入的密码不一致", 3);
      this.$post(
        "/spms/securitys/changePassword",
        {
          password: this.newPwd2,
        },
        {
          success(data) {
            this.stepDialog2 = 2;
            this.newPwd1 = "";
            this.newPwd2 = "";
          },
        }
      );
    },
    changeFile() {
      var file = document.getElementById("headFile");
      var filePath = file.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(filePath);
      reader.onload = function (e) {
        // document.getElementsByClassName("viewHead").src = this.result;
      };
    },
    saveDetail() {
      let data = {
        gender: this.profile.gender,
        department: this.profile.department,
        mailAddress: this.profile.mailAddress,
        mobileNumber: this.profile.mobileNumber,
        name: this.profile.name,
        position: this.profile.position,
        remark: "",
      };
      this.$post("/spms/myProfiles/changeMyProf", data, {
        success() {
          $msg.msg("保存成功!", 1);
        },
      });
    },
    getProfile() {
      this.$get("/spms/myProfiles/getProfile")
        .then((res) => (this.profile = res))
        .catch((err) => {});
    },
    unlink() {
      $alert({
        type: "remove",
        title: "确定解绑吗？",
        text: "一旦解绑微信将无法收到通知，请确定是否继续。",
        ok: () => {
          this.$post("/spms/wechat/unlink")
            .then((res) => {
              $msg.msg("解绑成功！");
              this.getProfile();
            })
            .catch((err) => {});
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ap-view-message {
  padding: 30px;
  background: #fff;
  .header {
    .name {
      font-family: "微软雅黑";
      font-weight: 400;
      font-size: 24px;
      color: #000;
    }
    .org {
      padding: 5px;
      color: #999;
    }
  }
  .phone,
  .password,
  .wechat {
    overflow: hidden;
    padding: 10px;
    div {
      color: #999;
      float: left;
      width: 160px;
    }
  }
}
.viewHead {
  width: 44px;
  height: 44px;
  float: left;
  border-radius: 50%;
}
.change {
  color: #09c !important;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.add {
  background: #ed1b23;
  padding: 0 30px;
  color: #fff;
}
.detail {
  width: 450px;
  li {
    padding: 10px 10px 10px 160px;
    position: relative;
    .left {
      position: absolute;
      left: 5px;
      line-height: 36px;
    }
  }
}
</style>